import numeral from 'numeral';

numeral.register('locale', 'pt-BR', {
  delimiters: { thousands: '.', decimal: ',' },
  currency: { symbol: 'R$' }
});

numeral.locale('pt-BR');

export default numeral;